import styled from 'styled-components'

export const StyledShopInfoSection = styled.section<{ showBorder: boolean, showTopDivider: boolean }>`
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  letter-spacing: 0.25px;
  max-width: 584px;
  border: ${({ showBorder }) => (showBorder ? '1px solid #ADADAD' : 'none')};
  border-top: ${({ showTopDivider }) => (showTopDivider ? '1px solid #EBEBEB' : '1px solid initial')};
  border-radius: ${({ showTopDivider }) => (showTopDivider ? '0' : '4px')};
  padding: ${({ showBorder }) => (showBorder ? '12px 16px' : '0 0 10px 0')};
  padding-top: ${({ showTopDivider }) => (showTopDivider ? '12px' : '16px')};

  button {
    width: ${({ showBorder }) => showBorder && '100%'};
  }

  @media (max-width: 1024px) {
    max-width: 100%;

    button {
      width: 100%;
    }
  }
`

export const StyledShopInfoHeader = styled.header`
  margin-bottom: 3px;
  display: flex;
  font-weight: 700;
`

export const StyledShopMessage = styled.div`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
  margin-bottom: 10px;
`
